//import liraries
import React  from 'react';
import { View, StyleSheet } from 'react-native';
import CImage from './CImage';
import CText from './CText';

// create a component
const CViewBenifits = (props) => {
    return (
        <View style={styles.container}>
            <View style={styles.contentStyle}>
            <View style={{width:"70%"}}>
            {
                props.headerText
                &&
                <CText.benifitHeaderText>{props.headerText}</CText.benifitHeaderText>
            }
            <CText.benifitText>
                {props.text}
            </CText.benifitText>
            </View>
            <View style={{marginRight:20}}>
            <CImage.BenifitImage source={props.imageSource} />
            </View>
            
            </View>
            {
                props.showBottomLine &&
                <View style={{width:"100%",height:0.5,backgroundColor:"#02122c",opacity:0.5,marginTop:3}} /> 
            }
             
        </View>
    );
};

// define your styles
const styles = StyleSheet.create({
    container: {
        width:"100%",
       paddingBottom:10
    },
    contentStyle: {
        flexDirection:"row",
        justifyContent:"space-between",
        width:"100%",
        marginHorizontal:10,
        paddingBottom:5,
        paddingLeft:5
    },
});

//make this component available to the app
export default CViewBenifits;
